import { SITE } from "../lib/site";
import { ShoppingBag, Star, ArrowUpRight } from "lucide-react";

export const EtsyShowcase = () => {
  return (
    <section
      id="shop"
      data-testid="etsy-section"
      className="relative bg-[#0a0a0a] border-b border-white/10 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32 grid md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-7">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-12 bg-[#FF2222]" />
            <span className="text-[11px] uppercase tracking-[0.3em] text-white/60">Etsy Store</span>
          </div>

          <h2 className="font-display uppercase text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.85] tracking-tighter">
            Shop the<br /> <span className="text-[#FF2222]">Collection</span>
          </h2>

          <p className="mt-6 text-white/70 text-base md:text-lg leading-relaxed max-w-xl">
            Browse ready-made designs, wedding party tees, and seasonal drops on our Etsy store. Want
            something custom? Send us a message instead — we love a challenge.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a
              data-testid="etsy-shop-cta"
              href={SITE.social.etsy}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-[#FF2222] hover:bg-white hover:text-black text-white uppercase font-bold tracking-wider text-xs md:text-sm px-8 py-4 inline-flex items-center gap-3 transition-colors"
            >
              <ShoppingBag size={16} /> Visit iza3nee on Etsy
              <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
            <div className="flex items-center gap-2 text-white/70 text-sm">
              {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-[#FF2222] text-[#FF2222]" />)}
              <span className="ml-2 uppercase tracking-[0.2em] text-xs">Handmade · Small batch</span>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 relative">
          <div className="relative bg-[#FF2222] aspect-square w-full overflow-hidden">
            <div className="absolute inset-0 grain opacity-30" />
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8">
              <ShoppingBag size={48} className="text-white mb-6" strokeWidth={1.5} />
              <div className="font-display text-white uppercase text-6xl md:text-7xl leading-none tracking-tight">
                iza3nee
              </div>
              <div className="font-display text-white/90 uppercase text-2xl md:text-3xl leading-none tracking-tight mt-1">
                creations
              </div>
              <div className="mt-6 text-white/90 text-[11px] uppercase tracking-[0.3em]">
                Etsy.com / shop
              </div>
            </div>
            <div className="absolute -bottom-2 -right-2 w-full h-full border-2 border-white/30" />
          </div>
        </div>
      </div>
    </section>
  );
};
